import { createGetArrangementsAction } from 'components/PLP/ArrangementsList/feature/actions';

export const getSuggestedArrangements = createGetArrangementsAction(
  'suggestedArrangements/get',
);
